// Static content data for Pro-Jet Nettoyage

export const COMPANY = {
  name: "Pro-Jet Nettoyage",
  city: "Québec",
  phone: "418 261-4715",
  phoneRaw: "+14182614715",
  email: "info@pro-jet-nettoyage.com",
  address: "Québec, QC, Canada",
  logo: "https://customer-assets.emergentagent.com/job_exterior-clean-pro-1/artifacts/11ya2fow_Lavage.png",
};

export const IMAGES = {
  hero: "https://images.pexels.com/photos/5652626/pexels-photo-5652626.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=1920",
  servicesEntry: "https://images.unsplash.com/photo-1781637202423-33ec5b47e52e?auto=format&fit=crop&w=1200&q=80",
  servicesPatio: "https://images.unsplash.com/photo-1580469322701-45b34d5e6e9b?q=80&w=2670&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  servicesSidewalk: "https://images.unsplash.com/photo-1629062690636-ef541e2aef3d?q=80&w=2673&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  servicesCommercial: "https://images.pexels.com/photos/35715655/pexels-photo-35715655.jpeg",
  servicesOther: "https://images.pexels.com/photos/14965464/pexels-photo-14965464.jpeg?cs=srgb&dl=pexels-antonio-lorenzana-bermejo-353570724-14965464.jpg&fm=jpg",
  servicesGarage: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?auto=format&fit=crop&w=1200&q=80",
  servicesBins: "https://images.unsplash.com/photo-1683516435482-f3cea544ee95?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85",
  beforeDirty: "https://images.pexels.com/photos/6197118/pexels-photo-6197118.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=800&w=1200",
  afterClean: "https://images.pexels.com/photos/5691660/pexels-photo-5691660.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=800&w=1200",
  gallery: [
    "https://images.pexels.com/photos/14965464/pexels-photo-14965464.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=800&w=1200",
    "https://images.pexels.com/photos/5691660/pexels-photo-5691660.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=800&w=1200",
    "https://images.pexels.com/photos/6197118/pexels-photo-6197118.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=800&w=1200",
    "https://images.pexels.com/photos/5652626/pexels-photo-5652626.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=800&w=1200",
    "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=1200&q=80",
  ],
};

export const SERVICES = [
  {
    id: "entree",
    title: "Lavage d'entrée",
    desc: "Béton et pavé uni. Retrouvez une entrée impeccable et débarrassée de la saleté incrustée.",
    image: IMAGES.servicesEntry,
  },
  {
    id: "patio",
    title: "Patios et terrasses",
    desc: "Nettoyage en profondeur du composite et de la pierre. Préparez vos espaces extérieurs pour la belle saison.",
    image: IMAGES.servicesPatio,
  },
  {
    id: "trottoirs",
    title: "Lavage de trottoirs",
    desc: "Trottoirs, allées et bordures nettoyés à haute pression pour un rendu net et sécuritaire.",
    image: IMAGES.servicesSidewalk,
  },
  {
    id: "commercial",
    title: "Lavage commercial",
    desc: "Stationnements, quais de chargement et surfaces extérieures. Solutions adaptées aux entreprises et copropriétés.",
    image: IMAGES.servicesCommercial,
    imagePosition: "bottom",
  },
  {
    id: "poubelles",
    title: "Lavage de poubelles",
    desc: "Bacs à ordures, recyclage et compost lavés, désinfectés et désodorisés à haute pression. Fini les mauvaises odeurs.",
    image: IMAGES.servicesBins,
  },
  {
    id: "autre",
    title: "Autre",
    desc: "Vous avez un projet particulier ? Contactez-nous pour un service sur mesure adapté à vos besoins.",
    image: IMAGES.servicesOther,
  },
];

export const ADVANTAGES = [
  { icon: "Zap", title: "Service rapide" },
  { icon: "Clock", title: "Ponctualité garantie" },
  { icon: "Tags", title: "Prix transparents" },
  { icon: "Wrench", title: "Équipement professionnel" },
];

export const STEPS = [
  { n: "01", title: "Réservez en ligne", desc: "Choisissez votre service, date et heure en quelques clics." },
  { n: "02", title: "Nous confirmons", desc: "Notre équipe vous contacte pour confirmer le rendez-vous." },
  { n: "03", title: "Nous effectuons le lavage", desc: "Une équipe professionnelle intervient avec du matériel haut de gamme." },
  { n: "04", title: "Vous profitez du résultat", desc: "Une propriété comme neuve — sans effort de votre part." },
];

export const FAQ = [
  {
    q: "Combien coûte un lavage à pression ?",
    a: "Le prix dépend du type de service, de la surface et du niveau de saleté. Utilisez notre formulaire de soumission pour recevoir un prix personnalisé rapidement.",
  },
  {
    q: "Dois-je être présent lors du service ?",
    a: "Non, votre présence n'est pas obligatoire tant que nous avons accès à la zone à nettoyer et à une prise d'eau extérieure.",
  },
  {
    q: "Quels modes de paiement acceptez-vous ?",
    a: "Nous acceptons les paiements par carte de crédit, virement Interac et argent comptant.",
  },
  {
    q: "Combien de temps dure le nettoyage ?",
    a: "La durée varie selon la surface. Un lavage d'entrée résidentielle prend généralement entre 1 et 3 heures.",
  },
];

// Service "Lavage de poubelles"
export const BINS_SERVICE_ID = "poubelles";
export const BINS_SERVICE_TITLE = "Lavage de poubelles";

export const BIN_TYPES = [
  { value: "ordures", label: "Ordures" },
  { value: "recyclage", label: "Recyclage" },
  { value: "compost", label: "Compost" },
];

export const BIN_COUNTS = ["1", "2", "3", "4+"];

export const BIN_FREQUENCIES = [
  { value: "une_fois", label: "Lavage unique (1 fois)" },
  { value: "mensuel", label: "Lavage mensuel" },
  { value: "bimensuel", label: "Lavage bimensuel (2 fois/mois)" },
];

export const TIME_SLOTS = [
  "08:00", "09:00", "10:00", "11:00",
  "13:00", "14:00", "15:00", "16:00",
];
